var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8001 1.60001C4.58792 1.60001 4.38444 1.68429 4.23441 1.83432C4.08438 1.98435 4.0001 2.18783 4.0001 2.40001V3.20001H3.2001C2.77575 3.20001 2.36878 3.36858 2.06873 3.66864C1.76867 3.96869 1.6001 4.37566 1.6001 4.80001V12.8C1.6001 13.2244 1.76867 13.6313 2.06873 13.9314C2.36878 14.2314 2.77575 14.4 3.2001 14.4H12.8001C13.2244 14.4 13.6314 14.2314 13.9315 13.9314C14.2315 13.6313 14.4001 13.2244 14.4001 12.8V4.80001C14.4001 4.37566 14.2315 3.96869 13.9315 3.66864C13.6314 3.36858 13.2244 3.20001 12.8001 3.20001H12.0001V2.40001C12.0001 2.18783 11.9158 1.98435 11.7658 1.83432C11.6158 1.68429 11.4123 1.60001 11.2001 1.60001C10.9879 1.60001 10.7844 1.68429 10.6344 1.83432C10.4844 1.98435 10.4001 2.18783 10.4001 2.40001V3.20001H5.6001V2.40001C5.6001 2.18783 5.51581 1.98435 5.36578 1.83432C5.21575 1.68429 5.01227 1.60001 4.8001 1.60001ZM4.8001 5.60001C4.58792 5.60001 4.38444 5.68429 4.23441 5.83432C4.08438 5.98435 4.0001 6.18783 4.0001 6.40001C4.0001 6.61218 4.08438 6.81566 4.23441 6.96569C4.38444 7.11572 4.58792 7.20001 4.8001 7.20001H11.2001C11.4123 7.20001 11.6158 7.11572 11.7658 6.96569C11.9158 6.81566 12.0001 6.61218 12.0001 6.40001C12.0001 6.18783 11.9158 5.98435 11.7658 5.83432C11.6158 5.68429 11.4123 5.60001 11.2001 5.60001H4.8001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.c22c5f6bfd4257958d8a738cb9e690ad.svg";
export { ForwardRef as ReactComponent };